import React from "react";
import { Button } from "reactstrap";
import { Modal } from "react-bootstrap";
import Select from "react-select";

const StatusSelect = (props) => {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="recharge-transaction-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ marginBottom: 15 }}>
          <Select
            closeMenuOnSelect={true}
            placeholder={props.placeholder}
            onChange={props.handleChange}
            options={props.options}
            value={props.selectedOption}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide}>
          Cancel
        </Button>
        <Button variant="primary" color="primary" onClick={props.statusFilter}>
          Save{" "}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default StatusSelect;
